module.exports = __webpack_public_path__ + "985175c718d68160039e88291f58e96d.png";


//////////////////
// WEBPACK FOOTER
// ./src/logos/tsutaya.png
// module id = 81
// module chunks = 0